import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class AgentPostCalendarService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async get(postId, month) {
    const { data } = await this.httpClient.get(`/agent/api/post_calendars`, {
      params: { post_id: postId, month },
    })
    const { start_times_json, post_calendars_json, bokun_availabilities } = data
    const startTimes = bokun_availabilities
      ? []
      : this.serializer.parseResourceData(start_times_json, start_times_json.data)
    const postCalendars = bokun_availabilities
      ? []
      : this.serializer.parseResourceData(post_calendars_json, post_calendars_json.data)
    const bokunAvailabilities = bokun_availabilities

    return { startTimes, postCalendars, bokunAvailabilities }
  }

  public async create(params) {
    const { data } = await this.httpClient.post(`/agent/api/post_calendars`, params)
    const { post_calendar, flush } = data
    const postCalendar = this.serializer.parseResourceData(post_calendar, post_calendar.data)

    return { postCalendar, flush }
  }

  public async update(id, params) {
    const { data } = await this.httpClient.patch(`/agent/api/post_calendars/${id}`, params)
    const { post_calendar, flush } = data
    const postCalendar = this.serializer.parseResourceData(post_calendar, post_calendar.data)

    return { postCalendar, flush }
  }
}

export default AgentPostCalendarService
